import ConfigData from 'config/ConfigData';

const TweetsFilters = [
  {
    name: 'Exclude reposts',
    searchState: 'inbox',
    pages: ['Tweets'],
    filterName: 'isRetweet',
    type: 'toggle',
    value: false,
    phrase: 'excluding retweets',
    customOrder: 0,
    activeSearchCustomOrder: 1,
    hiddenDesktop: true,
    exportAsExternalFilter: true,
  },
  {
    name: 'Exclude reposts',
    searchState: 'referenceSection',
    pages: ['Tweets'],
    filterName: 'isRetweet',
    type: 'toggle',
    value: false,
    customOrder: 0,
    activeSearchCustomOrder: 1,
    updateFilter: true,
  },
  {
    name: 'Commentators',
    searchState: 'always',
    filterName: ConfigData?.filters?.commentators?.filterName,
    pages: ['Tweets'],
    hiddenDesktop: true,
    exportAsExternalFilter: true,
    options: ConfigData?.filters?.commentators?.options,
    hidden: ConfigData?.filters?.commentators?.hidden,
  },
  {
    name: 'X posts option',
    searchState: 'referenceSection',
    pages: ['Tweets'],
    filterName: 'isRetweet',
    optionSelected: '',
    options: [
      { name: 'Is X repost', filterValue: 'true' },
      { name: 'Is X post', filterValue: 'false' },
    ],
    hidden: true,
    updateHash: true,
    notUseFromLocalStorage: true,
  },
];

export default TweetsFilters;
